import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=1859c696&scoped=true&"
import script from "./LeaderBoard.vue?vue&type=script&lang=js&"
export * from "./LeaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=1859c696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859c696",
  null
  
)

export default component.exports